import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { updateUserConfiguration } from 'owa-session-store';

/* PLEASE DO NOT CHANGE THE BIT POSITIONS FOR THE FLAGS STORED IN SearchBitFlags */
export const enum SearchBitFlagsMasks {
    None = 0,
    ScopeInboxSearchToFolder = 1 << 1, // Flag to indicate whether searches in the Inbox folder should be scoped to the folder or all folders.  0 => false (scope to all folder), 1 => true (scope to folder)
    // MAX = 1 << 31
}

/**
 * Gets a boolean to indicate if the n th bit is 1
 * @param bitMask represents the nth bit
 * @return true if nth bit is 1, false if 0
 */
export function getIsBitSet(bitMask: SearchBitFlagsMasks): boolean {
    let searcbBitFlags = getUserConfiguration().ViewStateConfiguration.SearchBitFlags;
    return !!(bitMask & searcbBitFlags);
}

/**
 * Set bit flag
 * @param value set to 1 if true, 0 otherwise
 * @param bitMask represents the nth bit
 */
export function setBit(value: boolean, bitMask: SearchBitFlagsMasks) {
    // Already same value, no need to set again and update user config
    if (getIsBitSet(bitMask) === value) {
        return;
    }

    updateUserConfiguration(userConfig => {
        if (value) {
            // Set the bit to 1
            userConfig.ViewStateConfiguration.SearchBitFlags |= bitMask;
        } else {
            // Clear the bit to 0
            userConfig.ViewStateConfiguration.SearchBitFlags &= ~bitMask;
        }
    });
}
